// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__18Iww","info":"Note_info__1Np4A","note":"Note_note__61v8r","actions":"Note_actions__1OchC"};